<template>
  <v-ons-page id="account">
    <h1 class="page-title">{{ $t("account.title") }}</h1>
    <form action="" class="search-box" v-if="false">
      <ons-search-input :placeholder="Search" modifier="full"></ons-search-input>
    </form>
    <div class="account-info container">
      <div class="justify-row">
        <div class="avatar">
          <img-with-placeholder class="round-max" :src="constants.phImg70x70" :data-src="sizeImg(currentUser.avatar_base_url, 70, 70)" :alt="currentUser.avatar.alt_text" />
        </div>
        <div>
          <h1 class="h2">{{ currentUser.name }}</h1>
          <div class="quiet small followers" v-if="false"><span class="follower-count">117</span> followers</div>
          <div>
            <v-ons-button modifier="small" class="btn-outline js-newpage" @click="navigatorPush('ProfileEdit')" :disabled="currentUser._is_guest">
              <icon-edit />
              <span>{{ $t("account.edit") }}</span>
            </v-ons-button>
            <span>&nbsp;</span>
            <v-ons-button class="btn-outline" modifier="small" @click="logOut()" v-show="!currentUser._is_guest">
              <icon-exit />
              <span>{{ $t("account.logout") }}</span>
            </v-ons-button>
            <v-ons-button class="btn-outline" modifier="small" @click="logIn()" v-show="currentUser._is_guest">
              <icon-login />
              <span>{{ $t("account.login") }}</span>
            </v-ons-button>
          </div>
        </div>
      </div>
      <p class="p">{{ currentUser.bio }}</p>
      <div class="center-align" v-if="false">
        <ons-button modifier="small" class="btn-outline js-donate" data-host="David French">
          <icon-donate />
          <span>Donate</span>
        </ons-button>
        <span>&nbsp;</span>
        <ons-button modifier="small" class="btn-outline js-newpage" data-page="payment-methods.html">
          <icon-bank-card />
          <span>Payment Methods</span>
        </ons-button>
      </div>
    </div>
    <div class="account-gap border-top"></div>
    <div class="pd-bottom">
      <ons-list>
        <ons-list-item tappable class="js-newpage" @click="showA2hs" v-if="!$isCordova">{{ $t("account.install") }}</ons-list-item>
        <ons-list-item modifier="chevron" tappable @click="navigatorPush('ChangePassword')" v-show="!currentUser._is_guest">{{ $t("account.change_pw") }}</ons-list-item>
        <ons-list-item modifier="chevron" tappable @click="navigatorPush('NotificationSettings')" v-show="!currentUser._is_guest">{{ $t("account.notf_settings") }}</ons-list-item>
        <ons-list-item modifier="chevron" tappable @click="navigatorPush('AutoDownloadSettings')" v-show="!currentUser._is_guest">{{ $t("account.auto_download_settings") }}</ons-list-item>
        <ons-list-item v-show="!currentUser._is_guest">
          <div class="center">{{ $t("account.auto_play") }}</div>
          <div class="right por-rm switch-wp">
            <v-ons-switch
              :modelProp="currentUser.auto_play_enabled"
              :disabled="isOffline"
              @change="toggleAutoPlayEnabled($event)"
            />
            <icon-progress-circular v-show="autoPlayEnabledLoading" />
          </div>
        </ons-list-item>
        <ons-list-item v-show="!currentUser._is_guest">
          <div class="center">{{ $t("account.dark_mode") }}</div>
          <div class="right por-rm switch-wp">
            <v-ons-switch
              :modelProp="currentUser.dark_mode_enabled"
              :disabled="isOffline"
              @change="toggleDarkModeEnabled($event)"
            />
            <icon-progress-circular v-show="darkModeEnabledLoading" />
          </div>
        </ons-list-item>
        <ons-list-item v-show="!currentUser._is_guest">
          <div class="center">{{ $t("account.offline_support_disabled") }}</div>
          <div class="right por-rm switch-wp">
            <v-ons-switch
              :modelProp="currentUser.offline_support_disabled"
              :disabled="isOffline"
              @change="toggleOfflineSupportDisabled($event)"
            />
            <icon-progress-circular v-show="offlineSupportDisabledLoading" />
          </div>
        </ons-list-item>
        <ons-list-item modifier="chevron" tappable @click="navigatorPush('PrivacySettings')" v-show="!currentUser._is_guest">{{ $t("account.privacy_settings") }}</ons-list-item>
        <ons-list-item modifier="chevron" tappable @click="navigatorPush('SkipRewindSettings')" v-show="!currentUser._is_guest">{{ $t("account.skip_rewind_settings") }}</ons-list-item>
        <ons-list-item modifier="chevron" tappable @click="navigatorPush('SleepTimerSettings')" v-show="!currentUser._is_guest">{{ $t("account.sleep_timer_settings") }}</ons-list-item>
        <ons-list-item tappable @click="openLanguageActionSheet">
          <div class="center">{{ $t("account.language") }}</div>
          <div class="right por-rm switch-wp">
            <icon-progress-circular v-show="uiLangaugeLoading" />
          </div>
        </ons-list-item>
        <ons-list-item class="danger" tappable @click="cancelAccount()" v-show="!currentUser._is_guest">
          <div class="center">{{ $t("account.cancel_acc") }}</div>
          <div class="right por-rm switch-wp">
            <icon-progress-circular v-show="cancelAccountLoading" />
          </div>
        </ons-list-item>
        <ons-list-item tappable @click="showTipsDialog({ force: true, tipIndex: 0 })">{{ $t("account.usage_tips") }}</ons-list-item>
        <ons-list-item tappable @click="showRateAppDialog({ force: true })" v-if="!!$isCordova">{{ $t("account.rate_feedback") }}</ons-list-item>
        <ons-list-item modifier="chevron" tappable @click="navigatorPush('AboutUs')">{{ $t("account.about_us") }}</ons-list-item>
      </ons-list>
    </div>
  </v-ons-page>
</template>

<script>
import PopupHelper from '@/mixins/PopupHelper';
import UiLanguageHelper from '@/mixins/UiLanguageHelper';

export default {
  name: 'account',
  mixins: [PopupHelper, UiLanguageHelper],

  data() {
    return {
      unwatches: [],
      autoPlayEnabledLoading: false,
      darkModeEnabledLoading: false,
      offlineSupportDisabledLoading: false,
      cancelAccountLoading: false,
    };
  },

  methods: {
    showA2hs() {
      this.$a2hs.show({force: true});
    },
    logOut() {
      if (this.showGoOnlineToast(this.$t("messages.go_online_to_log_out"))) { return; }
      let that = this;
      this.$store.dispatch('player/close');
      if (that.$isCordova) {
        try {
          window.plugins.googleplus.logout();
        } catch(_) {}
        try {
          window.facebookConnectPlugin.logout();
        } catch(_) {}
      }
      this.destroyPushNotification().finally(() => {
        this.$store.dispatch('currentUser/logOut');
      });
      this.navigatorResetLogin();
    },
    logIn() {
      this.navigatorPushLogin({allowPop: true});
    },
    cancelAccount() {
      if (this.showGoOnlineToast(this.$t("messages.go_online_to_cancel_acc"))) { return; }
      let that = this;

      this.$ons.notification.confirm(this.$t("messages.cancel_acc_confirm")).then((response) => {
        if (!response) { return; }
        this.cancelAccountLoading = true;
        this.$ons.notification.toast(this.$t("messages.deleting_data"), { timeout: 3000, animation: 'fall' });
        this.$store.dispatch('player/close');
        if (that.$isCordova) {
          try {
            window.plugins.googleplus.logout();
          } catch(_) {}
          try {
            window.facebookConnectPlugin.logout();
          } catch(_) {}
        }
        this.destroyPushNotification().finally(() => {
          that.currentUser.delete().then(() => {
            return that.$store.dispatch('currentUser/reset');
          }).then(() => {
            that.navigatorResetLogin();
            that.$ons.notification.toast(that.$t("messages.acc_deleted"), { timeout: 5000, animation: 'fall' });
          }).catch(() => {
            that.showSomethingWrongToast();
          }).finally(() => {
            that.cancelAccountLoading = false;
          });
        });
      });
    },
    toggleAutoPlayEnabled(event) {
      if (!event.isInteractive) { return; }
      let that = this;
      this.autoPlayEnabledLoading = true;
      this.currentUser.toggleAutoPlayEnabled()
        .catch(() => {
          that.showSomethingWrongToast();
        }).finally(() => {
          this.autoPlayEnabledLoading = false;
        });
    },
    toggleDarkModeEnabled(event) {
      if (!event.isInteractive) { return; }
      let that = this;
      this.darkModeEnabledLoading = true;
      this.currentUser.toggleDarkModeEnabled()
        .catch(() => {
          that.showSomethingWrongToast();
        }).finally(() => {
          this.darkModeEnabledLoading = false;
        });
    },
    toggleOfflineSupportDisabled(event) {
      if (!event.isInteractive) { return; }
      let that = this;
      this.offlineSupportDisabledLoading = true;
      this.currentUser.toggleOfflineSupportDisabled()
        .catch(() => {
          that.showSomethingWrongToast();
        }).finally(() => {
          this.offlineSupportDisabledLoading = false;
        });
    },
  },
};
</script>
